
module.exports = (err) => {
  const message = err && err.message;
  return !message
    || /(Failed to fetch|NetworkError|cannot connect|closed)/gim.test(message);
};
